import { IState } from "./interfaces";

const threshold = 50;

export const isNearAnyDrop = ({ drops, left, top }: { drops: IState["drops"], left: number, top: number}) => {
    let target;
    drops.forEach((drop, index) => {
        if (Math.abs(drop.t - top) < threshold && Math.abs(drop.l - left) < threshold) {
            target = index;
        }
    });
    return (typeof target === "number" ? target : null) as number | null;
};
